module.exports = __webpack_public_path__ + "img/FlexiOffice_logo_new4.8b9ac73b.png";